import type {HTMLAttributes} from 'react'

import {cn} from '@/lib/utils'

export function Card({className, ...props}: HTMLAttributes<HTMLDivElement>) {
  return <div data-slot="card" className={cn('flex flex-col rounded-[16px] border bg-card text-card-foreground shadow-[var(--shadow-card)]', className)} {...props} />
}
